export const preview_preferences_events = {
  preview_preference_load: {
    category: "Preview preference page is loaded",
    action: "User navigates to preview preferences page",
    label: "preview-preference-load",
  },

  // Newly added events
  preferences_modal_close_button: {
    category: "Preferences modal interaction",
    action: "User clicks on close button in preferences modal",
    label: "pref-back-click",
  },
  pref_my_location_clear: {
    category: "Preferences modal interaction",
    action: "User clicks on clear button in inputting city",
    label: "pref-my-location-clear",
  },
  pref_my_location_option_click: {
    category: "Preferences modal interaction",
    action: "User clicks on location option ",
    label: "pref-my-location-option-click",
  },
  preferences_modal_home_city: {
    category: "Preferences modal interaction",
    action: "User selects home city in preferences modal",
    label: "pref-my-location-input",
  },
  preferences_modal_flight_stay_trip_preferences: {
    category: "Preferences modal interaction",
    action: "User sets flight/stay trip preferences",
    label: "pref-text-field-input",
  },
  preferences_modal_budget_economy: {
    category: "Preferences modal budget selection",
    action: "User selects Economy budget option",
    label: "pref-budget-economy-click",
  },
  preferences_modal_budget_mid_range: {
    category: "Preferences modal budget selection",
    action: "User selects Mid-range budget option",
    label: "pref-budget-mid-range-click",
  },
  preferences_modal_luxury: {
    category: "Preferences modal budget selection",
    action: "User selects Luxury budget option",
    label: "pref-budget-luxury-click",
  },
  preferences_dietary_restrictions_dropdown: {
    category: "Preferences dietary restrictions",
    action: "User opens dietary restrictions dropdown",
    label: "pref-dietary-restrictions-dropdown",
  },
  preferences_dietary_restrictions_option_click: {
    category: "Preferences dietary restrictions",
    action: "User selects option",
    label: "pref-dietary-option-click",
  },
  pref_travel: {
    category: "Preferences",
    action: "User interacts with travel preferences",
    label: "pref-travel",
  },

  preferences_interests_dropdown: {
    category: "Preferences interests",
    action: "User opens interests dropdown",
    label: "pref-interests-dropdown",
  },
  preferences_interests_dropdown_option_click: {
    category: "Preferences interests",
    action: "User selects option",
    label: "pref-interests-option-click",
  },
  preferences_done_button: {
    category: "Preferences modal interaction",
    action: "User clicks on Done button in preferences modal",
    label: "pref-save-click",
  },
};
